import { BaseProperties } from "./base.interface";

export enum MarketingEmailsReason {
  OTHER = "OTHER",
  TIKTOK = "TIKTOK",
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
}

export interface MarketingEmailsInput {
  name: string;
  email: string;
  reason: MarketingEmailsReason;
  description?: string;
}

export interface MarketingEmailsOutput
  extends BaseProperties,
    MarketingEmailsInput {}
